"use strict";

var Backbone = require('backbone');
var _ = require('underscore');

var constants = require('../constants');


var Bed = Backbone.Model.extend({
  getSleeps: function(){
    if(this.isExtended()){
      return 2;
    }
    if(this.isRetracted()){
      return 1;
    }

    return this.get('sleeps');
  },

  getSelectedCount: function () {
    return this.get('selected') || 0;
  },

  getMaxSelectedCount: function(){
    var left = this.get('bedConfiguration').getSleepsLeft();
    var selected = this.getSelectedCount();
    var max = selected + left;

    return max;
  },

  isExtra: function(){
    return !!this.get('isExtra');
  },

  remove: function(){
    var beds = this.get('room').get('beds');

    var pos = beds.indexOf(this);
    beds = beds.splice(pos, 1);

    this._triggerBedConfigChange();
  },

  setSelectedCount: function(count){
    this.set('selected', count);

    this._triggerBedConfigChange();
  },

  _triggerBedConfigChange: function(){
    this.get('bedConfiguration').trigger("change");
  },

  getDescription: function(){
    var descriptions = this.get('bedConfiguration').get('bed_descriptions');
    var bedType = this.get('bed_type');
    var description = _(descriptions).find(function(description){
      return description.type_id === bedType;
    });

    description = description ? description.description : null;

    return description;
  },

  getBedIconClass: function() {
    return constants.BED_TYPE_ICON_CLASSES[this.get('bed_type')];
  },

  _isCategoryExtendable: function(){
    return this.get("category") === "extendable";
  },

  _isCategoryJoinable: function(){
    return this.get("category") === "joinable";
  },

  getState: function(){
    if(this.get('state')){
      return this.get('state');
    }

    if(this._isCategoryExtendable()){
      return "retracted";
    }
    if(this._isCategoryJoinable()){
      return "joined";
    }

    return null;
  },



  isExtendable: function(){
    return this.getState() === "retracted";
  },

  isCurrentlyExtendable: function(){
    return this.isExtendable();
  },

  isExtended: function(){
    return this.getState() === "extended";
  },

  extend: function(){
    this.set("state", "extended");
    this._triggerBedConfigChange();
  },



  isRetractable: function(){
    return this.getState() === "extended";
  },

  isCurrentlyRetractable: function(){
    return this.isRetractable();
  },

  isRetracted: function(){
    return this.getState() === "retracted";
  },

  retract: function(){
    this.set("state", "retracted");

    if(this.getSelectedCount() > 1){
      this.set('selected', 1);
    }

    this._triggerBedConfigChange();
  },



  isJoinable: function(){
    return this.getState() === "separated";
  },

  isCurrentlyJoinable: function(){
    return this.isJoinable() && this.getMaxSelectedCount() >= 2;
  },

  isJoined: function(){
    return this.getState() === "joined";
  },

  join: function(){
    this.set("state", "joined");
    this.set('selected', 2);
    this._triggerBedConfigChange();
  },



  isSeparable: function(){
    return this.getState() === "joined";
  },

  isCurrentlySeparable: function(){
    return this.isSeparable && this.getMaxSelectedCount() >= 2;
  },

  isSeparated: function(){
    return this.getState() === "separated";
  },

  separate: function(){
    this.set("state", "separated");
    this.set('selected', 2);
    this._triggerBedConfigChange();
  }
});

module.exports = Bed;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/models/bed.js
 **/